import { render, staticRenderFns } from "./ChangeOrderComponent.vue?vue&type=template&id=6c587e20&"
import script from "./ChangeOrderComponent.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderComponent.vue?vue&type=script&lang=js&"
import style0 from "./ChangeOrderComponent.vue?vue&type=style&index=0&id=6c587e20&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports